import { newProperty } from "../schema.generator";

const newTaskSchema = [
  { ...newProperty("name", "string", true, "Name") },
  { ...newProperty("description", "string", true, "Description") },
  { ...newProperty("date", "date", false, "Date") },
];

export default newTaskSchema;
